export function setDocumentElementCSSVar(height, prop = '--announcement-height') {
  height = String(height).replace(/\D/g) + "px";

  document.documentElement.style.setProperty(prop, height);
}



// WEBPACK FOOTER //
// ./scripts/lib/header-height-css-var.js